"use strict";

exports.__esModule = true;
exports.defaultCommentTableWidgetColumns = void 0;
var defaultCommentTableWidgetColumns = exports.defaultCommentTableWidgetColumns = [{
  type: "DataTableColumn",
  props: {
    id: "deviceName",
    name: "Device",
    type: "deviceName",
    canFilter: true,
    showSearchFilter: false,
    enableSorting: true,
    defaultFilterValue: "",
    x: 0,
    y: 0,
    height: 64,
    width: 256
  },
  children: []
}, {
  type: "DataTableColumn",
  props: {
    id: "createdMillis",
    name: "Created At",
    type: "date",
    canFilter: true,
    showSearchFilter: true,
    enableSorting: true,
    defaultFilterValue: "",
    x: 0,
    y: 0,
    height: 64,
    width: 256,
    usePlantTime: true
  },
  children: []
}, {
  type: "DataTableColumn",
  props: {
    id: "author",
    name: "Created By",
    type: "author",
    canFilter: true,
    enableSorting: true,
    defaultFilterValue: "",
    x: 0,
    y: 0,
    height: 64,
    width: 256
  },
  children: []
}, {
  type: "DataTableColumn",
  props: {
    id: "body",
    name: "Comment",
    type: "string",
    canFilter: true,
    showSearchFilter: true,
    enableSorting: false,
    defaultFilterValue: "",
    x: 0,
    y: 0,
    height: 64,
    width: 256
  },
  children: []
}, {
  type: "DataTableColumn",
  props: {
    id: "editedTimestamp",
    name: "Edited At",
    type: "date",
    canFilter: true,
    showSearchFilter: true,
    enableSorting: true,
    defaultFilterValue: "",
    x: 0,
    y: 0,
    height: 64,
    width: 256,
    usePlantTime: true
  },
  children: []
}, {
  type: "DataTableColumn",
  props: {
    id: "editedBy",
    name: "Edited By",
    type: "author",
    canFilter: true,
    enableSorting: true,
    defaultFilterValue: "",
    x: 0,
    y: 0,
    height: 64,
    width: 256
  },
  children: []
}];